import React, { useCallback, useState } from "react";
import { PropTypes } from "prop-types";
import { List } from "react-window";
import reactWrapper from "@harbor/elements/utils/react/wrapper";

import { useI18n } from "../../../i18n/useI18n";
import ApiService from "../../../config/api-config";
import css from "../accountsMagneticStyle.less";
import { useMount } from "../../../utils/genericCommon";

const [
  HbrTabGroup,
  HbrTab,
  HbrTabPanel,
  HbrMenu,
  HbrInput,
  HbrIcon,
  HbrMenuItem,
  HbrSpinner,
  HbrDropdown,
  HbrButton,
] = reactWrapper([
  "hbr-tab-group",
  "hbr-tab",
  "hbr-tab-panel",
  "hbr-menu",
  "hbr-input",
  "hbr-icon",
  "hbr-menu-item",
  "hbr-spinner",
  "hbr-dropdown",
  "hbr-button",
]);

const SmartAccountTab = (props) => {
  const { tViews } = useI18n("views");
  const { supportAccountState, selectedTab } = props;
  const { originalSaList, isLoaded } = supportAccountState;
  const [filteredSaList, setFilteredSaList] = useState([]);
  const getAccountRowKey = useCallback(
    (index) => filteredSaList[index].name,
    [filteredSaList],
  );
  const mount = useMount();

  const onMenuOpen = async () => {
    if (selectedTab === "smartAccountTab" && mount.initMount) {
      mount.initMount = false;

      const result = await ApiService.getSupportRoleAccounts();

      if (!result.errorObject) {
        const accountDomains = result.data.data.map((accountDomain) => {
          return {
            name: accountDomain,
            text: accountDomain,
          };
        });

        props.onMenuOpen({
          isLoaded: true,
          originalSaList: accountDomains,
          filteredSaList: accountDomains,
        });

        setFilteredSaList(accountDomains);
      } else {
        props.onMenuOpen({
          errorObject: result.errorObject,
          isLoaded: false,
          originalSaList: [{ name: "none", text: tViews("smartAccountNone") }],
          filteredSaList: [{ name: "none", text: tViews("smartAccountNone") }],
        });
      }
    }
  };

  const onTabsChange = (e) => {
    props.onTabsChange({
      name: e.currentTarget.value,
      smartAccountName: e.currentTarget.name,
    });
    onMenuOpen();
  };

  const OverlayList = ({ ariaAttributes, index, style }) => {
    let { name, text } = filteredSaList[index];

    return (
      <div {...ariaAttributes} className="ListItem" style={style}>
        <HbrMenuItem
          key={name}
          name={name}
          onClick={onTabsChange}
          value={"domainAccountTab"}
        >
          <div id={`account_id_${text}`}>{text}</div>
        </HbrMenuItem>
      </div>
    );
  };

  OverlayList.propTypes = {
    ariaAttributes: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    style: PropTypes.object.isRequired,
  };

  const searchSmartAccount = (e) => {
    const filteredList = originalSaList.filter((sa) =>
      sa.text.toString().toLowerCase().includes(e.target.value),
    );

    setFilteredSaList(
      filteredList.length > 0
        ? filteredList
        : [{ name: "none", text: tViews("smartAccountNone") }],
    );
  };

  return (
    <div className={css["smart-account-tab"]}>
      <HbrTabGroup primary>
        <HbrTab
          key="smartAccount"
          data-testid={"tab-smart-account"}
          slot="nav"
          sentiment="success"
          panel={"smartAccountTab"}
          onHbr-click={onTabsChange}
          active={selectedTab === "smartAccountTab"} // Ensure this tab is active when selected
        >
          {tViews("smartAccount")}
        </HbrTab>
        <HbrTab
          key={"smartAccountSupportRole"}
          id={isLoaded}
          data-testid={"tab-smart-account-support-role"}
          slot="nav"
          sentiment="success"
          panel={"smartAccountSupportRole"}
          onHbr-click={onTabsChange}
          active={selectedTab !== "smartAccountTab"}
          nested={true}
          ariahidden="true"
          onClick={onMenuOpen}
        >
          <HbrDropdown
            slot="menu"
            hoist
            trigger="click"
            menu={true}
            menuFitTrigger
            distance="2"
            placement="bottom-end"
          >
            <HbrButton ariarole="tab" slot="trigger" variant="context" caret>
              {tViews("smartAccountSupportRole")}
            </HbrButton>
            <HbrMenu>
              <div className="site-menu-container">
                <div id="search-support-role">
                  {filteredSaList.length > 0 && (
                    <HbrInput
                      className="support-container"
                      size="medium"
                      placeholder={tViews("smartAccountPlaceHolder")}
                      clearable
                      onHbr-input={searchSmartAccount}
                    >
                      <div slot="prefix">
                        <HbrIcon sentiment="neutral" name="magnifying-glass" />
                      </div>
                    </HbrInput>
                  )}
                </div>
                {filteredSaList.length ? (
                  <List
                    className="List"
                    rowComponent={OverlayList}
                    rowCount={filteredSaList.length}
                    rowHeight={40}
                    rowKey={getAccountRowKey}
                    rowProps={{}}
                    style={{ height: 200, width: 300 }}
                  />
                ) : (
                  <div className="spinner-search-support-role">
                    <HbrSpinner size="medium"></HbrSpinner>
                  </div>
                )}
              </div>
            </HbrMenu>
          </HbrDropdown>
        </HbrTab>
        <HbrTabPanel name="smartAccountSupportRole"></HbrTabPanel>
      </HbrTabGroup>
    </div>
  );
};

SmartAccountTab.propTypes = {
  supportAccountState: PropTypes.object.isRequired,
  selectedTab: PropTypes.string,
  onMenuOpen: PropTypes.func.isRequired,
  onTabsChange: PropTypes.func.isRequired,
  index: PropTypes.string,
  style: PropTypes.object,
};
export default SmartAccountTab;
